import script from "./CustomerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__